import { SERVICE_TYPE } from '@hedepy/common/enums/SERVICE_TYPE'
import useSWR from 'swr'

import { useApis } from '@/legacy-src/contexts/api-context'
import { useSession } from '@/legacy-src/contexts/session-context'

export const useClientFreeIntroSessionEligibility = (serviceType: number | undefined) => {
  const { isLoggedIn } = useSession()
  const { api } = useApis()

  const shouldCheck = isLoggedIn && serviceType === SERVICE_TYPE.FREE_DEMO

  const { data, isLoading } = useSWR(shouldCheck ? '/event/free-intro-session' : null, () =>
    api.getFreeIntroSessionEligibility().then((r) => r.data),
  )

  return {
    eligible: !shouldCheck || (data?.eligible ?? true),
    isLoading: shouldCheck && isLoading,
  }
}
